<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="平台编码">
            <platformSelecter :platformcode="searchP.platformcode"  @platformChange="handlePlatformChange"></platformSelecter>
        </a-form-item>
        <a-form-item label="配置编码">
            <configcodeSelecter ref="configcodeSelecterID" v-model="searchP.configcode"></configcodeSelecter>
        </a-form-item>

        <a-form-item label="数据表编号">
            <a-select v-model="searchP.tabIndex" style="width: 80px">
                <a-select-option value="0">表0</a-select-option>
                <a-select-option value="1">表1</a-select-option>
                <a-select-option value="2">表2</a-select-option>
                <a-select-option value="3">表3</a-select-option>
                <a-select-option value="4">表4</a-select-option>
                <a-select-option value="5">表5</a-select-option>
                <a-select-option value="6">表6</a-select-option>
                <a-select-option value="7">表7</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="层级编码">
            <a-input v-model="searchP.rangecode" placeholder="层级编码" allow-clear></a-input>
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
import configcodeSelecter from '../com/configcodeSelecter'
import platformSelecter from '../com/platformSelecter'

export default {
    components:{
        configcodeSelecter,
        platformSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                platformcode:'',
                configcode:'',
                tabIndex:'0',
                rangecode:'',
                platformlist:[]
            }
        }
    },
    methods:{
        handleConfigcodeChange(selectedKeys){
            if(selectedKeys.length > 0){
                this.searchP.configcode = selectedKeys[0]
            }
            else{
                this.searchP.configcode = ''
            }
        },
        handlePlatformChange(obj){
            this.$refs.configcodeSelecterID.setPlatform(obj.platformcode);
            this.searchP.platformcode = obj.platformcode;
            this.searchP.platformlist = obj.platformlist;
            this.handleSubmit();
        },
        handleSubmit(){
            this.$store.commit("save", {searchP_configdetail: this.searchP})
            this.$emit("handleSearch",this.searchP);
        },
    },
    mounted(){
        let searchP = this.$store.state.searchP_configdetail
        if(searchP){
            this.searchP = searchP
        }
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

